// extracted by mini-css-extract-plugin
export default {"label":"_3FDbbAD","refinementCount":"HiyL96q","value":"kx2nDmW","selected":"_2epgqE1","emptySwatch":"_2i4VA2k"};